module.exports = __webpack_public_path__ + "img/trade-icon-6.c7c3753b.svg";